const id=/^[A-Za-z0-9_-]{1,100}$/;
export function chatMessagePath(communityId:string|null,roomId:string,messageId?:string){
 if(!id.test(roomId)||communityId&&!id.test(communityId)||messageId&&!id.test(messageId))throw Error('Invalid message link.');
 return '/channels/'+(communityId||'@me')+'/'+roomId+(messageId?'/'+messageId:'');
}
export function parseChatLocation(path:string,search='',hash=''){
 const match=/^\/channels\/(@me|[A-Za-z0-9_-]{1,100})(?:\/([A-Za-z0-9_-]{1,100}))?(?:\/([A-Za-z0-9_-]{1,100}))?\/?$/.exec(path);
 if(match)return {communityId:match[1]==='@me'?null:match[1],roomId:match[2]||null,messageId:match[3]||null,legacy:false};
 const room=new URLSearchParams(search).get('room'),message=/^#message-([A-Za-z0-9_-]{1,100})$/.exec(hash)?.[1];
 if(path==='/'&&room&&id.test(room))return {communityId:null,roomId:room,messageId:message||null,legacy:true};
 return null;
}
